// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VnUE1","index":"styles_index__1AD9H"};